import(/* webpackMode: "eager" */ "/codebuild/output/src3398194454/src/base-speak-to-ai/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3398194454/src/base-speak-to-ai/src/app/providers/AppProviders.js");
